import { render } from "./AssetTable.vue?vue&type=template&id=1492e5dc"
import script from "./AssetTable.vue?vue&type=script&lang=js"
export * from "./AssetTable.vue?vue&type=script&lang=js"

import "./AssetTable.vue?vue&type=style&index=0&id=1492e5dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__